export enum TrailStatuses {
  Closed = 0,
  HighImpact = 1,
  MediumImpact = 2,
  LowImpact = 3,
}

export const trailStatuses = [
  { name: 'Closed', id: 0 },
  { name: 'High Impact', id: 1 },
  { name: 'Medium Impact', id: 2 },
  { name: 'Low Impact', id: 3 },
]
